import { useQuery } from '@tanstack/react-query';
import { voice } from '@repletoryreach/sdk-api';

/**
 * Whether Voice exists for this account, asked once and shared.
 *
 * Voice is built switched off (2 October 2026). The console shows nothing of
 * it, not a menu entry and not a page, unless the service says it is
 * available. Anything short of a clear yes (a failed request, a service that
 * is not deployed, an answer that says off) counts as no.
 */
export function useVoiceStatus() {
  const q = useQuery({
    queryKey: ['voice-status'],
    queryFn: () => voice.getStatus(),
    staleTime: 60_000,
    retry: false
  });
  const status = q.data?.data ?? null;
  return { status, available: status?.available === true, isPending: q.isPending, refetch: q.refetch };
}
